import { render, staticRenderFns } from "./HomeColorBar.vue?vue&type=template&id=521c679b&"
import script from "./HomeColorBar.vue?vue&type=script&lang=js&"
export * from "./HomeColorBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports